import React from 'react';
import { ProjectData } from '../../../data/projectsData';

// ProjectData를 확장하는 인터페이스 정의
interface ProjectCardProps extends ProjectData {
  featured?: boolean;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ 
  imageUrl, 
  title, 
  description, 
  date, 
  tags
}) => {
  return (
    <div className="
      relative group
      bg-white rounded-2xl
      border border-gray-100
      overflow-hidden">
      <div className="aspect-[16/9] overflow-hidden">
        <img 
          src={imageUrl}
          alt={title} 
          className="w-full h-full object-cover
            transform group-hover:scale-105
            transition-transform duration-500 ease-out"
        />
      </div>
      <div className="p-6 space-y-4">
        <div className="flex justify-between items-start">
          <h3 className="Pretendard-Bold text-gray-900 text-xl">
            {title}
          </h3>
          <span className="text-sm text-gray-500 whitespace-nowrap ml-4">
            {date}
          </span>
        </div>
        <p className="text-gray-600 line-clamp-2">
          {description}
        </p>
        <div className="flex flex-wrap gap-2 pt-2">
          {tags.map((tag: string, index: number) => (
            <span 
              key={index}
              className="px-3 py-1 text-sm rounded-full
                bg-gray-50 text-gray-600
                hover:bg-gray-100 transition-colors"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard; 